import classNames from 'classnames/bind';
import React, { useRef } from 'react';
import { RiFileDownloadLine, RiFileUploadLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';

import styles from './index.module.scss';

import actions from '@/actions';
import { getCommandForSurveySegment } from '@/helpers/CommandConverter';
import { NotifierService as notifier } from '@/libs/Notifier';
import { convertFencesToGeoJSON } from '@/utils/FenceUtil';
import { download } from '@/utils/FileDownloader';

const cx = classNames.bind(styles);

const FileTool = () => {
  const dispatch = useDispatch();
  const name = useSelector((state) => state.mission.name);
  const specs = useSelector((state) => state.mission.json.specs);
  const commands = useSelector((state) => state.mission.json.commands);
  const fences = useSelector((state) => state.mission.json.fences);
  const fileRef = useRef();

  const handleInput = (e) => {
    const file = e.target.files[0];
    const fileReader = new FileReader();
    fileReader.readAsText(file, 'UTF-8');
    fileReader.onload = (event) => {
      const data = JSON.parse(event.target.result);
      dispatch(actions.mission.load(data));
    };

    e.target.value = '';
  };

  const doUpload = () => {
    fileRef.current.click();
  };

  const doDownloadToJSON = (e) => {
    if (!validAll()) return;

    let source;
    const isEasterMode = e.ctrlKey || e.metaKey;
    if (isEasterMode) {
      source = convertFencesToGeoJSON(fences);
    } else {
      source = JSON.stringify({ name, json: { specs, commands, fences } });
    }

    const blob = new Blob([source], { type: 'text/json' });
    const filename = `${new Date().toISOString()}.json`;
    download(blob, filename);
  };

  const validAll = () => {
    if (commands.length === 0) {
      notifier.error('No mission defined.');
      return false;
    }
    if (name.trim() === '') {
      notifier.error('Please enter the mission name.');
      return false;
    }
    if (!validWithJumpToItem()) {
      notifier.error("Please check the item number in the 'Jump To Item'.");
      return false;
    }
    return true;
  };

  const validWithJumpToItem = () => {
    if (!commands.some(({ type }) => type === 'doJump')) return true;

    let jumpToItemNumber = 1;
    let commandCount = 0;

    commands.forEach((command) => {
      switch (command.type) {
        case 'doJump':
          jumpToItemNumber = Math.max(jumpToItemNumber, command.data.item);
          break;

        case 'navLand':
          // Parachute 항목 체크한 경우
          if (command.data.parachute) {
            commandCount += 3; // Waypoint, Parachute Enable, Release 반영
          }
          break;

        case 'navWaypoint':
          // Speed 항목 체크한 경우
          if (command.data.speed) {
            commandCount++; // Change Speed 반영
          }
          break;

        case 'cusSurvey':
          {
            const surveyCommand = getCommandForSurveySegment(command);
            commandCount += surveyCommand.data.positions.length - 1;
          }
          break;

        default:
          break;
      }

      commandCount++;
    });

    return jumpToItemNumber <= commandCount;
  };

  return (
    <div className={cx('group')}>
      <input ref={fileRef} hidden type="file" accept=".json" onInput={handleInput} />
      <div className={cx('button')} onClick={doUpload}>
        <RiFileUploadLine size={20} color="white" />
      </div>
      <div className={cx('button')} onClick={doDownloadToJSON}>
        <RiFileDownloadLine size={20} color="white" />
        <div className={cx('text')}>JSON</div>
      </div>
    </div>
  );
};

export default FileTool;
